import { OverlayModule } from '@angular/cdk/overlay';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { OverlayHandler, OverlayService } from './overlay.service';

/**
 * @stable
 */
@Component({
    imports: [OverlayModule],
    selector: 'vn-overlay',
    template: `<div id="main-overlay" [hidden]="!overlayHandler" (click)="hide()" (swipeleft)="hide()"></div>`,
})
export class OverlayComponent {
    private overlayService = inject(OverlayService);

    overlayHandler: OverlayHandler | null;

    readonly #destroyRef = inject(DestroyRef);

    constructor() {
        this.overlayService.activeHandler.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((handler) => {
            this.overlayHandler = handler;
        });
    }

    hide() {
        if (this.overlayHandler && !this.overlayHandler.onClick()) {
            // NOTE: check again because onClick handler might have already closed the overlay
            if (this.overlayHandler) {
                this.overlayHandler.hide();
            }
        }
    }
}
